const index = (x) => ~~x;
export default index;
